export default __webpack_public_path__ + "static/aur_better_jobs-6bd4cf9c865b2322f1691700cbb89fe4.png";